import React from 'react';
import Products from './Products';

import Contact from './Contact';
const Main = () => (
	<>
		<Products />

		<Contact />
	</>
);
export default Main;
